import * as React from "react";
import type { SVGProps } from "react";
const SvgEuroWithExclamation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.241 19.383A6.54 6.54 0 0 0 11 20a6.54 6.54 0 0 0 5-2.34 1.001 1.001 0 0 0-.434-1.61 1.004 1.004 0 0 0-1.076.29 4.42 4.42 0 0 1-6.9 0A6.83 6.83 0 0 1 6.727 15H11a1 1 0 0 0 0-2H6.105a6.83 6.83 0 0 1 0-2H11a1 1 0 0 0 0-2H6.724c.217-.445.483-.868.796-1.26A4.59 4.59 0 0 1 11 6a4.58 4.58 0 0 1 3.5 1.66A1 1 0 1 0 16 6.34 6.53 6.53 0 0 0 11 4a6.56 6.56 0 0 0-5 2.46A8.899 8.899 0 0 0 4.56 9H3a1 1 0 0 0 0 2h1.08a8.9 8.9 0 0 0-.013 2H3a1 1 0 0 0 0 2h1.517A8.9 8.9 0 0 0 6 17.66a6.54 6.54 0 0 0 2.241 1.723ZM21 15a1 1 0 0 1-1-1V7a1 1 0 0 1 2 0v7a1 1 0 0 1-1 1ZM20.29 17.71c.192.183.445.286.71.29h.2l.18-.1a.762.762 0 0 0 .18-.09l.15-.12a1.15 1.15 0 0 0 .21-.33.94.94 0 0 0 0-.76 1.15 1.15 0 0 0-.21-.33l-.15-.12a.762.762 0 0 0-.18-.09L21.2 16a1 1 0 0 0-.91.29 1.15 1.15 0 0 0-.21.33.94.94 0 0 0 0 .76c.048.123.119.235.21.33Z"
    />
  </svg>
);
export default SvgEuroWithExclamation;
